import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'

//const BLANK_GROUP_PROFILE_IMAGE = '/assets/images/default_group.svg'
const BLANK_GROUP_PROFILE_IMAGE = '/assets/images/blank_profile.png'

@Component({
    selector: 'fm-group-avatar',
    imports: [CommonModule],
    templateUrl: './fm-group-avatar.component.html',
    styleUrl: './fm-group-avatar.component.scss',
})
export class FmGroupAvatarComponent {
    @Input() avatarLocation: string

    public groupAvatar: string

    ngOnChanges() {
        this.groupAvatar = this.avatarLocation || BLANK_GROUP_PROFILE_IMAGE
    }

    public onProfileImageFailedToLoad() {
        this.groupAvatar = BLANK_GROUP_PROFILE_IMAGE
    }
}
